export const BILLING_ADMIN_ROLES = ["WB-ADMIN", "EMAIL-ADMIN", "CRM-ADMIN"];

export const SERVICE_LABELS = {
    "EMAIL-USER": "Email",
    "EMAIL-AGENT": "Email AI",
    "WB-ADMIN": "WhatsApp template",
    "WB-CHAT": "WhatsApp chat",
    "WB-AGENT": "WhatsApp bot",
    PERSONAL: "Personal WhatsApp",
    topup: "Credits added",
    adjustment: "Credits removed",
};

/** Role tokens that can appear on a ledger or top-up row, but are not spend services. */
const ROLE_DISPLAY = {
    "WB-USER": "WhatsApp User",
    "EMAIL-ADMIN": "Email Admin",
    EMAIL: "Business Email",
    "CRM-ADMIN": "CRM Admin",
    "CRM-USER": "CRM User",
    "EMAIL-VALIDATION": "Email validation",
};

export const CATEGORY_LABELS = {
    MARKETING: "Marketing",
    UTILITY: "Utility",
    AUTHENTICATION: "Authentication",
};

export const UNIT_LABELS = {
    per_message: "Per message",
    per_1000_tokens: "Per 1,000 tokens",
};

export const isCreditBased = (billingType) => billingType === "CREDIT_BASED";

export const parseRoleList = (raw) => {
    if (raw == null || raw === "") return [];
    let value = String(raw).trim().replace(/^"|"$/g, "");
    try {
        value = decodeURIComponent(value);
    } catch {
        // Cookie is already decoded.
    }
    return value
        .split(",")
        .map((role) => role.trim())
        .filter(Boolean);
};

export const isBillingAdmin = (roles = []) =>
    roles.some((role) => BILLING_ADMIN_ROLES.includes(role));

export const isOwnWallet = (wallet) => {
    if (!wallet || wallet.user_id == null || wallet.wallet_user_id == null) return false;
    return String(wallet.user_id) === String(wallet.wallet_user_id);
};

export const formatRupeesFromPaisa = (paisa) => {
    const n = Number(paisa);
    if (!Number.isFinite(n)) return "—";
    return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(n / 100);
};

export const formatCreditCount = (paisa) => {
    const n = Number(paisa);
    if (!Number.isFinite(n)) return "—";
    return `${new Intl.NumberFormat("en-IN").format(Math.trunc(n))} credits`;
};

export const displayRole = (role) => {
    if (role == null || role === "") return "";
    const key = String(role).trim();
    const upper = key.toUpperCase();
    return SERVICE_LABELS[key] || SERVICE_LABELS[upper] || ROLE_DISPLAY[key] || ROLE_DISPLAY[upper] || key;
};

export const formatRolesForDisplay = (raw) => {
    const roles = Array.isArray(raw) ? raw : parseRoleList(raw);
    return roles.map(displayRole).filter(Boolean).join(", ");
};

const LEDGER_SERVICE_ORDER = ["EMAIL-USER", "EMAIL-AGENT", "WB-ADMIN", "WB-CHAT", "WB-AGENT", "PERSONAL"];

/** Ledger services this account can actually spend, based on their roles. */
export const ledgerServicesForRoles = (roles = []) => {
    const upper = new Set(roles.map((role) => String(role).trim().toUpperCase()));
    const services = new Set();
    if (upper.has("EMAIL-USER") || upper.has("EMAIL") || upper.has("EMAIL-ADMIN")) services.add("EMAIL-USER");
    if (upper.has("EMAIL-AGENT") || upper.has("EMAIL-ADMIN")) services.add("EMAIL-AGENT");
    if (upper.has("WB-ADMIN") || upper.has("WB-USER")) services.add("WB-ADMIN");
    if (upper.has("WB-CHAT")) services.add("WB-CHAT");
    if (upper.has("WB-AGENT")) services.add("WB-AGENT");
    if (upper.has("PERSONAL")) services.add("PERSONAL");
    return [...LEDGER_SERVICE_ORDER.filter((service) => services.has(service)), "topup", "adjustment"];
};

export const serviceLabel = (service, templateCategory) => {
    const base = displayRole(service) || "—";
    const category = CATEGORY_LABELS[templateCategory];
    return category ? `${base} · ${category}` : base;
};

export const formatWhen = (value) => {
    if (!value) return "—";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "—";
    return date.toLocaleString("en-IN", {
        day: "numeric",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
};

export const rupeesToPaisa = (rupees) => {
    const n = Number(rupees);
    if (!Number.isFinite(n)) return null;
    return Math.round(n * 100);
};
